import * as yup from 'yup'

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  password: yup.string().required('Please enter a valid password'),
  publicDevice: yup.boolean()
})

export const ForgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email is required')
})

export const ResetPasswordSchema = yup.object().shape({
  password: yup.string().required('Please enter a valid password'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Password does not match')
    .required('Please enter a valid password')
})

export const magicLinkSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  publicDevice: yup.boolean()
})
